module.exports = __webpack_public_path__ + "img/link_monthlyrank.1dae4ed7.png";